import type { StakeholderFilters } from "@/infrastructure/repositories/stakeholders.supabase.repository";

export const stakeholdersKeys = {
  all: ["stakeholders"] as const,
  list: (filters: StakeholderFilters = {}) => [...stakeholdersKeys.all, "list", filters] as const,
  detail: (id: string) => [...stakeholdersKeys.all, "detail", id] as const,
};
